import { patchSetPricingIdsToAgent, postSyncPricingsToCdnByAgentId, Pricing } from '@nemuru-eng/js-api-client';
import { getPricingsFromCdnByAgentId } from '@nemuru-eng/js-api-client/slim';
import { Dispatch, SetStateAction, useState } from 'react';
import { useParams } from 'react-router-dom';

import { usePricingSelector } from '@/components/modules/AgentDetail/ProvidersDetails/components/AgentPricings/components/PricingSelector/hooks/usePricingSelector';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';
import { compareTwoArraysAndRemoveObjectWithEqualKeyValues } from '@/utils/compareTwoArraysAndRemoveObjectWithEqualKeyValues';

interface UseRemovePricingFromAgentProps {
  selectedPricing: Pricing;
  setOpened: Dispatch<SetStateAction<boolean>>;
}

export const useRemovePricingFromAgent = ({ selectedPricing, setOpened }: UseRemovePricingFromAgentProps) => {
  const { agentId } = useParams();
  const { request } = useRequest();

  //FIXME: Hay que arrelgar este hook, crear un componente para el dialog de eliminar pricing para el agente en el PricingActionsRowDialog
  if (!agentId) {
    return { removePricingFromAgent: () => {}, loading: false };
  }

  const { revalidate } = useCache(getPricingsFromCdnByAgentId, { agentId });
  const { getAgentPricings, agentPricings } = usePricingSelector({ agentId });

  const [loading, setLoading] = useState(false);

  const removePricingFromAgent = async () => {
    const removedPricings = compareTwoArraysAndRemoveObjectWithEqualKeyValues('id', agentPricings, [selectedPricing]);
    setLoading(true);
    await request(patchSetPricingIdsToAgent, { id: agentId, pricingIds: removedPricings.map((pricing) => pricing.id) });
    await getAgentPricings();
    await request(postSyncPricingsToCdnByAgentId, { agentId });
    setLoading(false);
    setOpened(false);
    revalidate();
  };

  return { removePricingFromAgent, loading };
};
